<script>
import MethodButtonBase from './MethodButtonBase';
import IconCertSign from '../../assets/svg/certsign.svg';
export default {
  name: 'CertSignUsbButton',
  components: {
    MethodButtonBase,
    IconCertSign,
  },
}
</script>

<template>
  <MethodButtonBase>
    <template v-slot:slot1>
      <IconCertSign :class="$style.icon" />
    </template>
    <template v-slot:slot2>
      {{ $t('USB') }}
    </template>
  </MethodButtonBase>
</template>

<style lang="scss" module>
.icon {
  display: block;
  width: 104px;
  height: auto;
  margin-right: 8px;
}
</style>
